<div class="modal-container">
  <div class="transfer-container">
    <div class="inner-container">
      <div class="header">
        <p class="title">{{ errorMessage }}</p>
        <svg class="close-btn" id="fac-close-btn" (click)="clickClose()" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="#2A2A2A"/>
        </svg>   
      </div>
      <div class="button-container">
        <div class="button-btns">
          <lib-button-tertiary id="copy-all" (click)="copyTranferFacs()">Copiar tudo</lib-button-tertiary>
        </div>
      </div>
     
      <div class="custom__table">
        <table>
          <div>
            <tr class="header clickable">
              <th>
              <div>
               <app-arrow-label (sort)="customSort($event)">Nome</app-arrow-label>
              </div>
              </th>
            </tr>
            <div>
              <tbody class="body">
                <tr *ngFor="let item of bulkErrorItems;">
                  <td>
                    <span>
                      {{ item }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </div>
          </div>
        </table>
      </div>
    </div>
  </div>
</div>
